<div class="grid-container h-100-p">
  <dx-data-grid
    [height]="'100%'"
    [width]="'100%'"

    [hoverStateEnabled]="true"
    keyExpr="role"

    [(selectedRowKeys)]="userRolesSelected"
    (onSelectionChanged)="selectionChanged($event)"

    [dataSource]="userRolesKeyValue"

    [columnAutoWidth]="true"

    [allowColumnReordering]="true"
    [allowColumnResizing]="true"

    [showColumnLines]="false"
    [showRowLines]="false"
    [showBorders]="true"
    [rowAlternationEnabled]="false"

  >
    <dxo-toolbar>
      <dxi-item
        name="searchPanel"
        locateInMenu="auto"
        location="after">
      </dxi-item>
      <dxi-item location="after">
        <button mat-button (click)="assignDefaultAccess()">Defaut</button>
      </dxi-item>

    </dxo-toolbar>

    <dxo-selection mode="multiple" showCheckBoxesMode="always"></dxo-selection>

    <dxo-search-panel [visible]="true" [width]="'70%'" [placeholder]="'Rechercher...' | translate"></dxo-search-panel>
    <dxo-filter-panel [visible]="true"></dxo-filter-panel>
    <dxo-group-panel [visible]="false"></dxo-group-panel>

    <dxo-scrolling mode="virtual" useNative="true" showScrollbar="always"></dxo-scrolling>

  </dx-data-grid>
</div>
